export default "__VITE_ASSET__azdGuZ9X__"